import { Controller } from "@hotwired/stimulus"
import { customTooltips } from "@coreui/chartjs"
import { getStyle } from "@coreui/utils"
import Chart from "chart.js/auto"

const months = ["January", "February", "March", "April", "May", "June", "July"]

export default class extends Controller {
  connect() {
    this.charts = []
    this.configureChartDefaults()
    this.createUserCharts()

    this.updateCharts = this.updateCharts.bind(this)
    document.documentElement.addEventListener("ColorSchemeChange", this.updateCharts)
    this.updateCharts()
  }

  disconnect() {
    document.documentElement.removeEventListener("ColorSchemeChange", this.updateCharts)
    this.charts.forEach((chart) => chart.destroy())
  }

  configureChartDefaults() {
    Chart.defaults.elements.point.hitRadius = 1
    Chart.defaults.plugins.tooltip.enabled = false
    Chart.defaults.plugins.tooltip.mode = "index"
    Chart.defaults.plugins.tooltip.position = "nearest"
    Chart.defaults.plugins.tooltip.external = customTooltips
    Chart.defaults.color = getStyle("--cui-body-color")
  }

  createUserCharts() {
    this.userChart = this.createChart("card-chart1", {
      type: "line",
      data: {
        labels: months,
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: "transparent",
            borderColor: "rgba(255,255,255,.55)",
            pointBackgroundColor: getStyle("--cui-primary"),
            data: [65, 59, 84, 84, 51, 55, 40],
          },
        ],
      },
      options: {
        plugins: { legend: { display: false } },
        maintainAspectRatio: false,
        scales: {
          x: {
            border: { display: false },
            grid: { display: false },
            ticks: { display: false },
          },
          y: {
            min: 30,
            max: 89,
            display: false,
            grid: { display: false },
            ticks: { display: false },
          },
        },
        elements: {
          line: { borderWidth: 1, tension: 0.4 },
          point: { radius: 4, hitRadius: 10, hoverRadius: 4 },
        },
      },
    })

    this.createChart("card-chart3", {
      type: "line",
      data: {
        labels: months,
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: "rgba(255,255,255,.2)",
            borderColor: "rgba(255,255,255,.55)",
            data: [78, 81, 80, 45, 34, 12, 40],
            fill: true,
          },
        ],
      },
      options: {
        plugins: { legend: { display: false } },
        maintainAspectRatio: false,
        scales: { x: { display: false }, y: { display: false } },
        elements: {
          line: { borderWidth: 2, tension: 0.4 },
          point: { radius: 0, hitRadius: 10, hoverRadius: 4 },
        },
      },
    })

    this.createChart("card-chart4", {
      type: "bar",
      data: {
        labels: [
          ...months,
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
          "April",
        ],
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: "rgba(255,255,255,.2)",
            borderColor: "rgba(255,255,255,.55)",
            data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
            barPercentage: 0.6,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false, drawTicks: false }, ticks: { display: false } },
          y: { border: { display: false }, grid: { display: false, drawTicks: false }, ticks: { display: false } },
        },
      },
    })
  }

  createChart(id, configuration) {
    const canvas = this.element.querySelector(`#${id}`)
    if (!canvas) return

    Chart.getChart(canvas)?.destroy()
    const chart = new Chart(canvas, configuration)
    this.charts.push(chart)
    return chart
  }

  updateCharts() {
    Chart.defaults.color = getStyle("--cui-body-color")
    if (!this.userChart) return

    this.userChart.data.datasets[0].pointBackgroundColor = getStyle("--cui-primary")
    this.userChart.update()
  }
}
